import React from 'react';
import { Calendar } from 'lucide-react';
import { StatutoryDeadline } from '../../services/practiceManagementService';

interface Props {
  deadlines: StatutoryDeadline[];
}

export const StatutoryDeadlinesTicker: React.FC<Props> = ({ deadlines }) => {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#131316] p-5 space-y-3">
      <div className="flex items-center justify-between border-b border-white/5 pb-2.5">
        <div className="flex items-center gap-2 text-xs font-bold uppercase text-slate-300">
          <Calendar className="h-4 w-4 text-cyan-400" />
          <span>Statutory Filing Calendar & Countdown Ticker</span>
        </div>
        <span className="text-[11px] text-slate-500">Live Indian GST Deadlines</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 pt-1">
        {deadlines.map((dl, idx) => (
          <div
            key={idx}
            className={`p-3.5 rounded-xl border text-xs flex flex-col justify-between ${
              dl.status === 'OVERDUE'
                ? 'border-rose-500/30 bg-rose-950/20 text-rose-200'
                : dl.status === 'DUE_SOON'
                ? 'border-amber-500/30 bg-amber-950/20 text-amber-200'
                : 'border-white/5 bg-[#0e1015] text-slate-300'
            }`}
          >
            <div>
              <div className="flex items-center justify-between font-bold">
                <span className="text-white">{dl.form}</span>
                <span
                  className={`font-mono text-[10px] px-1.5 py-0.2 rounded font-bold ${
                    dl.status === 'OVERDUE'
                      ? 'bg-rose-500/30 text-rose-300'
                      : dl.status === 'DUE_SOON'
                      ? 'bg-amber-500/30 text-amber-300'
                      : 'bg-emerald-500/20 text-emerald-400'
                  }`}
                >
                  {dl.daysRemaining < 0
                    ? `${Math.abs(dl.daysRemaining)}d OVERDUE`
                    : `${dl.daysRemaining} days left`}
                </span>
              </div>
              <div className="text-[10px] text-slate-400 mt-1">{dl.targetCategory}</div>
            </div>
            <div className="mt-3 pt-2 border-t border-white/5 text-[10px] font-mono text-slate-400 flex justify-between">
              <span>Due Date:</span>
              <span className="font-bold text-white">{dl.dueDate}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
